import homeMainBanner from "./modules/homeBannerSlider";
import homeServicesSlider from "./modules/homeServicesSlider";
import homeStoresSlider from "./modules/homeStoresSlider";
import homeBlogSlider from "./modules/homeBlogSlider";
import homeReviewSlider from "./modules/homeReviewsSlider";
import pageClinicalStaffSlider from "./modules/pageClinicalStaffSlider";
import headerMenuDropdown from './modules/headerMenuDropdown'
import pageUnity from './modules/pageUnity'

window.addEventListener("load", () => {
  homeMainBanner.init();
  homeServicesSlider.init();
  homeStoresSlider.init();
  homeBlogSlider.init();
  homeReviewSlider.init();
  pageClinicalStaffSlider.init();
  headerMenuDropdown.init();
  pageUnity.init();
});
